/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

export default class AutomationFinAiAgentTestingRoute extends Route {
  @service declare realTimeEventService: $TSFixMe;
  @service declare intl: IntlService;

  get titleToken(): string {
    return this.intl.t('ai-agent.sub-menu.playground.title');
  }
  // This runs when entering any route under /testing
  activate() {
    this.realTimeEventService.subscribeTopics(['fin-playground']);
  }

  // This runs when leaving the /testing hierarchy completely
  deactivate() {
    this.realTimeEventService.unsubscribeTopics(['fin-playground']);
  }
}
